/* eslint-disable */
import {
  Dropdown,
  Form,
  Modal,
  Select,
  Steps,
  DatePicker,
  Button,
  Tooltip,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
const { Step } = Steps;
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import { FormOutlined, MenuOutlined, HistoryOutlined } from "@ant-design/icons";
import commonFn from "@/utils/commonFn";

import { useNavigate } from "react-router-dom";
const { RangePicker } = DatePicker;
const MainTable = forwardRef((props, ref) => {
  const childRef = useRef();
  const [tableList, setTableList] = useState([]); // 表格数据
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // 筛选后的数据
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [options, setOptions] = useState([10, 20, 30]);
  const [selectedList, setSelectedList] = useState([]);
  const inputRefs = useRef({});
  const [refreshKey, setRefreshKey] = useState(0);
  const [pickerDates, setPickerDates] = useState(null);
  const [predictedDates, setpredictedDates] = useState(null);
  const initialTableHead = {
    status: "completed",
    completedRemark: null,
    completedByName: null,
    remark: null,
    groupSupervisor: null,
    propUnit: null,
    unitStatus: null,
    propType: null,
    units: null,
    unitStatus: null,
    sCompletedTime: null,
    eCompletedTime: null,
    sCreateTime: null,
    eCreateTime: null,
    city: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const navigate = useNavigate();

  const items = [
    {
      key: "edit",
      icon: <FormOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>Edit Approval Information</div>,
    },
  ];
  // 映射表单 ，转化配置
const fieldMap = {
  jobs: "job",   // jobs -> job
  
};
  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      columns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false } // 如果列的 key 在 checkedValues 中，显示该列
              : { ...col, hidden: true } // 否则隐藏该列
        );
      });
    },
    getSearchValues: () => {
      return {
        completedByName: inputRefs.current.completedByName?.input?.value || "",
        completedRemark: inputRefs.current.completedRemark?.input?.value || "",
        remark: inputRefs.current.remark?.input?.value || "",
        groupSupervisor: inputRefs.current.groupSupervisor?.input?.value || "",
        propUnit: inputRefs.current.propUnit?.input?.value || "",
        unitStatus: inputRefs.current.unitStatus?.input?.value || "",
        propType: inputRefs.current.propType?.input?.value || "",
        units: inputRefs.current.units?.input?.value || "",
        unitAddress: inputRefs.current.unitAddress?.input?.value || "",
        city: inputRefs.current.city?.input?.value || "",
      };
    },

    newListFun: () => {
      // setTableHead(initialTableHead);
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
      setRefreshKey((prev) => prev + 1);
      inputRefs.current.remark.input.value = "";
    },
  }));

  // 表格筛选input
const handleOk = (dates, confirm, startKey, endKey) => {
  if (dates && dates.length === 2) {
    const startDate = dates[0].format("MM/DD/YYYY");
    const endDate = dates[1].format("MM/DD/YYYY");
    const startTime = dates[0].valueOf();
    const endTime = dates[1].valueOf();

    handleApiCall(startDate, endDate, startTime, endTime, confirm, startKey, endKey);
  } else {
    return;
  }
};

// 通用的 API 调用
const handleApiCall = async (
  startDate,
  endDate,
  startTime,
  endTime,
  confirm,
  startKey,
  endKey
) => {
  console.log("Fetching data for:", startDate, endDate);
  setTableHead((prev) => {
    const updatedTableHead = {
      ...prev,
      [startKey]: startTime,
      [endKey]: endTime,
    };
    console.log("Updated tableHead:", updatedTableHead);
    getTableListFn(1, pagination.pageSize, updatedTableHead);
    return updatedTableHead;
  });
  if (confirm) {
    confirm(); //  关闭下拉
  }
};
// 通用 Reset
const handleReset = (setDates, startKey, endKey, clearFilters) => {
  clearFilters?.();
  setDates([]);
  setTableHead((prev) => {
    const updatedTableHead = {
      ...prev,
      [startKey]: "",
      [endKey]: "",
    };
    getTableListFn(1, pagination.pageSize, updatedTableHead);
    return updatedTableHead;
  });
};

  const handleDetailClick = (record) => {
    console.log("record", record);
    const params = record;
    const baseUrl = window.location.origin;
    const route = "/JobRequests/NonMaintenanceHistory/Detail";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };


  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  // 定义列，包括输入框
  const initColumns = [
    // {
    //   title: "#",
    //   key: "#",
    //   dataIndex: "#",
    //   hidden: false,
    //   align: "center",
    //   width: 50,
    //   render: (text, record, index) =>
    //     (pagination.current - 1) * pagination.pageSize + index + 1, // 计算序号
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "index",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record) =>
        (commonFn.btnAuthorityFlag("ViewDetail") && (
          <Dropdown
            menu={{
              items: [
                {
                  key: "view",
                  icon: <HistoryOutlined twoToneColor="#1677FF" />,
                  label: <div>View Detail</div>,
                },
              ],
              onClick: (e) => handleDetailClick(record), // 将 record 传递到事件中
            }}
            trigger={["click"]}
          >
            <MenuOutlined className="col-blue" />
          </Dropdown>
        )) ||
        null,
    },

    {
      title: "Completed Date",
      dataIndex: "completedTime",
      key: "completedTime",
      width: 170,
      align: "center",
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={predictedDates}
            onChange={(dates) => {
              setpredictedDates(dates);
              handleOk(dates, confirm, "sCompletedTime", "eCompletedTime");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setpredictedDates,
                "sCompletedTime",
                "eCompletedTime",
                clearFilters
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
    },

    {
      title: "Comp.Remark",
      dataIndex: "completedRemark",
      titleType: "Input",
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "completedRemark"),
    },

    {
      title: "Completed By",
      dataIndex: "completedByName",
      titleType: "Input",
      width: 140,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "completedByName"),
    },

    {
      title: "Create Date",
      dataIndex: "createTime",
      key: "createTime",
      width: 170,
      align: "center",
      sorter: true,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={pickerDates}
            onChange={(dates) => {
              setPickerDates(dates);
              handleOk(dates, confirm, "sCreateTime", "eCreateTime");
            }}
          />
          <Button
            size="small"
            style={{ width: 60, marginLeft: 10 }}
            onClick={() =>
              handleReset(
                setPickerDates,
                "sCreateTime",
                "eCreateTime",
                clearFilters
              )
            }
          >
            Reset
          </Button>
        </div>
      ),
      render: (text) => moment(text).format("MM/DD/YYYY HH:mm"),
    },
    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "remark"),
    },

    {
      title: "Group-Supervisor",
      dataIndex: "groupSupervisor",
      titleType: "Input",
      width: 170,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "groupSupervisor"),
    },

    {
      title: "Prop-Unit",
      dataIndex: "propUnit",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "propUnit"),
    },

    {
      title: "Unit Status",
      dataIndex: "unitStatus",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unitStatus"),
    },

    {
      title: "Prop Type",
      dataIndex: "propType",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "propType"),
    },
    {
      title: "Units",
      dataIndex: "units",
      titleType: "Input",
      width: 80,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "units"),
    },
    {
      title: "Unit Address",
      dataIndex: "unitAddress",
      titleType: "Input",
      width: 260,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unitAddress"),
    },
    {
      title: "City",
      dataIndex: "city",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "city"),
    },
  ];

  const columns = useMemo(() => {
    return initColumns.map((col) => {
      if (col.dataIndex === "#") {
        return {
          ...col,
          render: (text, record, index) =>
            (pagination.current - 1) * pagination.pageSize + index + 1,
        };
      }
      return col;
    });
  }, [initColumns, pagination.current, pagination.pageSize]);
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };


  useEffect(() => {
    if (
      (tableHead.sCompletedTime && tableHead.eCompletedTime) ||
      (tableHead.sCreateTime && tableHead.eCreateTime)
    ) {
      getTableListFn(1, 100, tableHead); // 查询全部数据
    }
  }, [
    tableHead.sCompletedTime,
    tableHead.eCompletedTime,
    tableHead.sCreateTime,
    tableHead.eCreateTime,
  ]);
  // 初始化数据
  useEffect(() => {
    setTableLoading(true);
    getTableListFn(pagination.current, pagination.pageSize);
  }, [childRef]);

  //列表
  const getTableListFn = async (page, pageSize, params = {}) => {
    try {
      setTableLoading(true);
      const queryParams = {
        page,
        count: pageSize,
        status: "completed",
        completedRemark: params.completedRemark || "",
        completedByName: params.completedByName || "",
        remark: params.remark || "",
        groupSupervisor: params.groupSupervisor || "",
        propUnit: params.propUnit || "",
        unitStatus: params.unitStatus || "",
        propType: params.propType || "",
        units: params.units || "",
        city: params.city || "",
        unitAddress: params.unitAddress || "",
        sCompletedTime: params.sCompletedTime || "",
        eCompletedTime: params.eCompletedTime || "",
        sCreateTime: params.sCreateTime || "",
        sCreateTime: params.eCreateTime || "",
        orderField: params.orderField || "",
        orderType: params.orderType || "",
      };

      // 过滤掉空值参数
      const filteredParams = Object.fromEntries(
        Object.entries(queryParams).filter(([_, v]) => v !== "")
      );

      // console.log("Request params:", filteredParams);

      // 先发送请求获取 response
      const response = await http.get(`${api.onpenMaintenanceShow}`, {
        params: filteredParams,
      });

      //unitAddress
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));
      console.log("dataWithKey", dataWithKey);
      setTableList(dataWithKey);
      setTableLoading(false);
      setFilteredData(dataWithKey);
      console.log("======设置分页2");
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total,
        pageSize: pageSize,
      }));
      console.log(pagination);
      props.updateMessage(dataWithKey);
    } catch (err) {
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  // 处理分页变化    table筛选
  const handleTableChange = (newPagination, filters, sorter) => {
    console.log("跳转");
    // 需要传递当前的 tableHead 搜索条件 \搜索
    let orderField = "";
    let orderType = "";
    if (sorter && sorter.field) {
        orderField = fieldMap[sorter.field] || sorter.field;
      orderType = sorter.order === "ascend" ? "asc" : "desc";
    }
    // getTableListFn(newPagination.current, newPagination.pageSize, tableHead);
    getTableListFn(newPagination.current, newPagination.pageSize, {
      ...tableHead,
      orderField,
      orderType,
    });
  };

  const handlePageSizeChange = useCallback((value) => {
    setPageSize(value);
    setCurrentPage(1); // 切换 pageSize 后，重置页码
  }, []);

  const itemRender = useCallback(
    (current, type, originalElement) => {
      if (type === "next") {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            {originalElement}
            <Select
              defaultValue={pageSize}
              className="select-style"
              style={{ width: 80, margin: "0 10px" }}
              onSelect={handlePageSizeChange}
              options={options.map((item) => ({
                value: item,
                label: `${item} `,
              }))}
            />
          </div>
        );
      }
      return originalElement;
    },
    [pagination.pageSize, handlePageSizeChange, options]
  );

  //复选框
  const rowSelection = {
    // 通过 getCheckboxProps 控制第一行不显示复选框
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, // 隐藏复选框
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      //选中
      console.log(selectedRowKeys);
      console.log(selectedRows);
      setSelectedList(selectedRows);
      props.deleteNum(selectedRows); //调用父组件方法
    },
  };

  return (
    <div>
      <CustomTable
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        setTableHead={setTableHead} // 必需
        getTableListFn={getTableListFn} //
      />
    </div>
  );
});
export default MainTable;
